module.exports = __webpack_public_path__ + "static/images/22a28a52820d680efb501c31d179d7aa.svg";